/*
 *
 *   reducer
 *
 */
import produce from "immer"
//import key from './key'

import {
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,
  LOAD_OBS_LIST_SUCCESS,
  LOAD_OBS_LIST_ERROR,
  
  UPDATE_OBS_LIST_SUCCESS,
  UPDATE_OBS_LIST_ERROR,
 
  DELETE_OBS_ERROR,
  DELETE_OBS_SUCCESS,
  ADD_FOLLOWUP_SUCCESS,
  ADD_FOLLOWUP_ERROR,
  LOAD_FOLLOWUP_SUCCESS,
  LOAD_FOLLOWUP_ERROR,
  
 
} from "./constants"

const initialState = {
  obsDetails: [],
  obsMetaData: {},
  employee_list: [],
  submitFollowUp:{},
  obs_list: [],
  loading: false,
  error: false,
  success: false,
  records:[],
  deleteData:{},
  followup_list:[]
}

export default function Reducer(
  state = initialState,
  {
    type,
    obsMetaData = {},
   submitFollowUp={},
    error,
    employee_list,
    success,
    obs_list,
    obsDetails=[],
   deleteData={},
   followup_list=[]
  }
) {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_META_DATA_SUCCESS:
        draft.obsMetaData = Object.assign(
          {},
          state.obsMetaData,
          obsMetaData
        )
        draft.error = false
        draft.success = success
        break

      case LOAD_EMPLOYEE_SUCCESS:
        draft.employee_list = employee_list
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case LOAD_OBS_LIST_SUCCESS:
        draft.obs_list = obs_list
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case UPDATE_OBS_LIST_SUCCESS:
        draft.obsDetails = obsDetails
        draft.loading = false
        draft.error = false
        draft.success = success
        break
        case ADD_FOLLOWUP_SUCCESS:
          draft.submitFollowUp = submitFollowUp
          draft.loading = false
          draft.error = false
          draft.success = success
          break
        case DELETE_OBS_SUCCESS:
          draft.deleteData = deleteData
          draft.loading = false
          draft.error = false
          draft.success = success
          break
          case LOAD_FOLLOWUP_SUCCESS:
            draft.followup_list = followup_list
            draft.loading = false
            draft.error = false
            draft.success = success
            break
      case ADD_FOLLOWUP_ERROR:
      case LOAD_EMPLOYEE_ERROR:
      case LOAD_OBS_LIST_ERROR:
      case LOAD_RECORDS_META_DATA_ERROR:
      case UPDATE_OBS_LIST_ERROR:
     case LOAD_FOLLOWUP_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = false
        break
        case DELETE_OBS_ERROR:
          draft.loading = false
          draft.error = error
          draft.success = false
          break
    }
  })
}
